import { ReactNode } from 'react'
import { cn } from '@/utilities/ui'

export type SectionBackground = 'white' | 'light-gray' | 'brand' | 'dark' | 'transparent'

export interface SectionWrapperProps {
  children: ReactNode
  background?: SectionBackground
  isDarkMode?: boolean
  className?: string
  container?: boolean
  fullWidth?: boolean
  padding?: 'none' | 'md' | 'lg'
}

export default function SectionWrapper({
  children,
  background = 'white',
  isDarkMode = false,
  className = '',
  container = true,
  fullWidth = false,
  padding = 'md',
}: SectionWrapperProps) {
  const backgroundClasses = {
    white: 'bg-background',
    'light-gray': 'bg-light-gray',
    brand: 'bg-brand',
    dark: 'bg-dark',
    transparent: 'bg-transparent',
  }

  const paddingClasses = {
    none: '',
    md: 'py-12 lg:py-24',
    lg: 'py-20 lg:py-32',
  }

  const containerClasses = container
    ? 'container mx-auto px-4 md:px-8'
    : fullWidth
      ? 'w-full'
      : 'max-w-7xl mx-auto px-4 md:px-8'

  return (
    <section
      className={cn(backgroundClasses[background], paddingClasses[padding], className)}
      {...(isDarkMode ? { 'data-theme': 'dark' } : {})}
    >
      <div className={containerClasses}>{children}</div>
    </section>
  )
}
